<template>
  <accordion-simple-item title="Artikelstamm" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="articleNumberSearch" type="text" placeholder="Artikelnummer eingeben..."
               class="p-2 w-full my-2 " :on-enter="getArticleNumbers"
               data-ui="input-search-product-article-master"></TRInput>

      <button class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              @click="getArticleNumbers" data-ui="button-search-product-article-master">Suchen
      </button>

      <spinner v-if="isLoading" class="col-span-4 w-full"/>

      <div class=" overflow-y-auto ">
        <div v-if="articleData !== null" v-for="article in  articleData " :key="article.articleId">
          <div class="w-full p-1 bg-trader-dark-gray flex my-2 hover:bg-trader-blue hover:text-white"
               @click="navigateTo(`/administration/${accordionIndex}/article`, { productId: article.productID })"  :data-ui='"searched-article-" + article.articleNumber'>
                  <span class="w-full">
                  {{ article.articleNumber }}
                 </span>
          </div>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import Spinner from "@/components/Base/Spinner.vue";

export default {
  name: "SPurchaser",
  data() {
    return {
      articleNumberSearch: '',
      articleData: null,
      isLoading: false,
    }
  },
  components: {
    Spinner,
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  props: {

    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  methods: {
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },
    async getArticleNumbers() {

      try {
        this.isLoading = true;
        // Define the variables for the query
        const variables = {
          articleNumber: this.articleNumberSearch // Ensure this variable is correctly assigned
        };
        // Execute the query
        const response = await apolloClient.query({
          query: gql`
                query getArticleNumbers($articleNumber: String!) {
                    getArticleNumbers(articleNumber: $articleNumber) {
                        articleId
                        articleNumber
                        productID
                    }
                }
            `,
          variables // Pass the variables to the query
        });
        // Access the data from the response
        this.articleData = response.data.getArticleNumbers;
      } catch (error) {
        console.error("Error while fetching article numbers", error);
      } finally {
        this.isLoading = false;
      }
    },
  },

}
</script>